import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';

import {
  UPDATE_COMMITMENTS_START,
} from '../../actions/types'

import {
  updateCommitmentsSuccess,
  updateCommitmentsFailure,
} from '../../actions'

import { putLoanApplicationUser } from '../../requesters/loanApplicationUser'
import {
  getLoanApplicationId,
  getCommitments,
  getCreditHistory,
} from '../../reducers'

function* loanUpdateCommitments(action) {
  const commitments = yield select(getCommitments);
  const creditHistory = yield select(getCreditHistory);
  const loanApplicationId = yield select(getLoanApplicationId);

  let data = {
    loan_application_user: {
      credit_history: creditHistory,
      commitments_attributes: commitments
    }
  }

  const { response, error } = yield call(putLoanApplicationUser, loanApplicationId, data)

  if (response) {
    yield put(updateCommitmentsSuccess(response))
  } else {
    yield put(updateCommitmentsFailure({
      entities: error.response.data.commitments,
      result: Object.keys(error.response.data.commitments),
    }))
  }
}

export function* watchLoanUpdateCommitments() {
  yield takeLatest(UPDATE_COMMITMENTS_START, loanUpdateCommitments)
}
